import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { handleErrors } from "common.js";
import { CircularProgress, Backdrop } from "@mui/material";

function AddVendor(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/vendor/addProfile",
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message));
          (function () {
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate('/vendor/list');
            }, 3000);
          })()
        }
        else {
          if (message)
            toast.error(t(message));
          if (response.data.errors.length > 0)
            response.data.errors.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: error.errors[0]
              });
            })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t('New vendor')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
              <MDBox px={3}>
                <Grid container spacing={2} mt={3}>
                  <Grid item xs={12} sm={3} md={3}>
                    <label className="font-style">{t('name')} <i className="mandatory">*</i></label>
                  </Grid>
                  <Grid item xs={12} sm={7} md={7}>
                    <MDInput type="text" name="name" label="" {...register("name", { required: true })} fullWidth />
                    {errors.name && errors.name.type === "required" && (
                      <p className="errorMsg">{t('Name is mandatory')}</p>
                    )}
                    {errors.name && (
                      <p className="errorMsg">{t(errors.name.message)}</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <label className="font-style">{t('email')} <i className="mandatory">*</i></label>
                  </Grid>
                  <Grid item xs={12} sm={7} md={7}>
                    <MDInput type="email" name="email" label="" {...register("email", { required: true })} fullWidth />
                    {errors.email && errors.email.type === "required" && (
                      <p className="errorMsg">{t('Email is mandatory')}</p>
                    )}
                    {errors.name && (
                      <p className="errorMsg">{t(errors.name.message)}</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <label className="font-style">{t('password')} <i className="mandatory">*</i></label>
                  </Grid>
                  <Grid item xs={12} sm={7} md={7}>
                    <MDInput type="password" name="password" label="" {...register("password", { required: true })} fullWidth />
                    {errors.password && errors.password.type === "required" && (
                      <p className="errorMsg">{t('Password is mandatory')}</p>
                    )}
                    {errors.password && (
                      <p className="errorMsg">{t(errors.password.message)}</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                  </Grid>
                  <Grid item xs={12} sm={7} md={7}>
                    <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t('Add')}</MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default AddVendor;
